import JurisdictionTable from './JurisdictionTable';

export default JurisdictionTable;
